import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { SaveTariffProposalItemCriteria } from "domain/entity/StandardProposal/SaveTariffProposalItemCriteria";
import { EMPTY_STANDARD_PROPOSAL_ENTITY, StandardProposalEntity } from "domain/entity/StandardProposal/StandardProposalEntity";
import { EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY, StandardProposalItemEntity } from "domain/entity/StandardProposal/StandardProposalItemEntity";
import { EMPTY_STD_PROPOSAL_IS_ENTITY, StdProposalIsEntity } from "domain/entity/StandardProposal/StdProposalIsEntity";
import { EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY, StdProposalTariffItemTierEntity } from "domain/entity/StandardProposal/StdProposalTariffItemTierEntity";
import { TariffCodeComboxSearchCriteria } from "domain/entity/StandardProposal/TariffCodeComboxSearchCriteria";
import { ExchangeRateRepository } from "domain/repository/ExchangeRate/ExchangeRateRepo";
import { StandardProposalItemRepository } from "domain/repository/StandardProposal/StandardProposalItemRepo";
import { StandardProposalRepository } from "domain/repository/StandardProposal/StandardProposalRepo";
import { StandardTariffCodeRepository } from "domain/repository/TariffCode/StandardTariffCodeRepo";
import { TariffNatureRepository } from "domain/repository/TariffNature/TariffNatureRepo";
import _ from "lodash";
import { createStandardProposalValidationSchema, createTariffItemValidationSchema, createTempSaveTariffItemTierValidationSchema } from "presentation/constant/StandardProposal/StandardProposalValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { DropdownProps } from "presentation/model/DropdownProps";
import { StandardProposalDetailModel } from "presentation/model/StandardProposal/StandardProposalDetailModel";
import { StandardProposalDropdownOptions, StandardProposalModel } from "presentation/model/StandardProposal/StandardProposalModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface StandardProposalDetailVMProps extends BaseViewModel {
    itemDispatch: [
        Dispatch<SetStateAction<StandardProposalDetailModel>> | ((value: SetStateAction<StandardProposalDetailModel>) => void),
    ],
    dispatch: [
        Dispatch<SetStateAction<StandardProposalModel>> | ((value: SetStateAction<StandardProposalModel>) => void),
    ],
    standardProposalItemRepo: StandardProposalItemRepository,
    exchangeRateRepo: ExchangeRateRepository,
    tariffNatureRepo: TariffNatureRepository,
    standardTariffCodeRepo: StandardTariffCodeRepository,
    standardProposalRepo: StandardProposalRepository,
}

export const StandardProposalDetailVM = ({ itemDispatch, dispatch, standardProposalItemRepo, standardTariffCodeRepo, standardProposalRepo }: StandardProposalDetailVMProps) => {
    const [standardProposalDetailDispatch] = itemDispatch;
    const [standardProposalDispatch] = dispatch;


    const onPageInit = (dynamicOption: StandardProposalDropdownOptions, tariffNatureMap: { [key: string]: string[] }) => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                currentStandardProposal: { ...EMPTY_STANDARD_PROPOSAL_ENTITY },
                standardProposalItemList: [],
                dynamicOptions: {
                    ...prevState.dynamicOptions,
                    companyCodeDropdownOptions: dynamicOption.companyCodeDropdownOptions,
                    operatingTmlDropdownOptions: dynamicOption.operatingTmlDropdownOptions,
                    tariffTypeDropdownOptions: dynamicOption.tariffTypeDropdownOptions,
                    tariffNatureDropdownOptions: dynamicOption.tariffNatureDropdownOptions,
                    shiftCodeDropdownOptions: dynamicOption.shiftCodeDropdownOptions,
                    currencyCodeDropdownOptions: dynamicOption.currencyCodeDropdownOptions,
                    forwarderCodeDropdownOptions: dynamicOption.forwarderCodeDropdownOptions,
                },
                detailState: {
                    ...prevState.detailState,
                    isAdd: true,
                },
                tariffNatureMap: tariffNatureMap
            }
        })
    }

    const onHeaderSingleDropdownChange = (e: any, fieldName: string) => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                currentStandardProposal: {
                    ...prevState.currentStandardProposal,
                    [fieldName]: e.value,
                },
                detailState: {
                    ...prevState.detailState,
                    allFormState: {
                        ...prevState.detailState.allFormState,
                        [fieldName]: ''
                    },
                }
            }
        });
    };

    const onHeaderMultipleDropdownChange = (e: any, fieldName: string) => {
        standardProposalDetailDispatch(prevState => ({
            ...prevState,
            currentStandardProposal: {
                ...prevState.currentStandardProposal,
                [fieldName]: _.uniq(e?.map((item: DropdownProps) => item.value)),
            }
        }));
    };

    const onHeaderFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                currentStandardProposal: {
                    ...prevState.currentStandardProposal,
                    [fieldKey]: val
                },
                detailState: {
                    ...prevState.detailState,
                    allFormState: {
                        ...prevState.detailState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onTariffNatureFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        standardProposalDetailDispatch(prevState => {
            let oldTariffNature: any = prevState.currentStandardProposal.tariffNatureList;
            let message = "";
            if (oldTariffNature && (oldTariffNature?.length ?? 0) > 0) {
                const missingValue = oldTariffNature?.find((x: any) => !(val || []).includes(x));
                if (oldTariffNature && oldTariffNature.length > (val?.length ?? 0)) {
                    let tariffNature: { [key: string]: string[] } = prevState.tariffNatureMap;
                    if (tariffNature.hasOwnProperty(missingValue)) {
                        let value = tariffNature[missingValue];
                        let currentStandardItem: StandardProposalItemEntity[] = prevState.standardProposalItemList;

                        if (currentStandardItem && !_.isEmpty(currentStandardItem)) {
                            for (const item of currentStandardItem) {
                                let concatenatedString = `${item.tariffType}_${item.tariffCode}`;
                                if (value.includes(concatenatedString)) {
                                    message = `Cannot delete the tariff nature - ${missingValue}. Tariff codes which under this tariff nature exists in the proposal.`;
                                    val = oldTariffNature;
                                    break
                                }
                            }
                        }
                    }
                }
            }

            return {
                ...prevState,
                currentStandardProposal: {
                    ...prevState.currentStandardProposal,
                    [fieldKey]: val,
                },
                detailState: {
                    ...prevState.detailState,
                    allFormState: {
                        ...prevState.detailState.allFormState,
                        [fieldKey]: ''
                    }
                },
                allFormState: { "updateNewTariffNatureFail": message }
            }
        })
    }

    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        standardProposalDetailDispatch(prevState => ({
            ...prevState,
            currentStandardProposal: {
                ...prevState.currentStandardProposal,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const onTextAreaChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        return standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                currentStandardProposal: {
                    ...prevState.currentStandardProposal,
                    [fieldKey]: val,
                }
            }
        });
    }

    const searchStandardProposalItem = async (entity: StandardProposalEntity) => {
        if (!entity.key) {
            return;
        }
        await standardProposalItemRepo.searchStandardProposalItem(entity).then((data) => {
            standardProposalDetailDispatch(prevState => {
                return {
                    ...prevState,
                    standardProposalItemList: data,
                    selectedRows: [],
                }
            })
        }).catch((error) => {
            return [];
        })
    }

    const updateSelectedRows = async (rows: any[]) => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                currentSelectItemRows: rows,
                currentSelectItem: rows.length === 1 ? rows[0] : { ...EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY },
                isShowAddTariffItemPanel: rows.length === 1 ? true : false,
                isAddTariffItem: false,
                isEditTariffItem: true,
                currentEditTariffItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY }
            }
        })
    }

    const onResetClick = async () => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                standardProposalItemList: [],
                currentStandardProposal: { ...EMPTY_STANDARD_PROPOSAL_ENTITY },
            }
        })
    }

    const onCloseClick = () => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                detailState: {
                    ...prevState.detailState,
                    allFormState: {
                    },
                }
            }
        })
        standardProposalDispatch(prevState => {
            return {
                ...prevState,
                isShowDetail: false,
                isBackFromDetail: true,
                isAllowAutoSearch: true,
                selectedRows: [],
                currentSelectedRow: { ...EMPTY_STANDARD_PROPOSAL_ENTITY },
            }
        });
    }

    const onAddTariffItemClick = async (stdProposal: StandardProposalEntity) => {
        const valResult = await Validation(createStandardProposalValidationSchema).ValidateFormOnly(stdProposal);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDetailDispatch(prevState => {
                return {
                    ...prevState,
                    detailState: {
                        ...prevState.detailState,
                        allFormState: validatedResult
                    }
                }
            });
        } else {
            standardProposalDetailDispatch(prevState => {
                return {
                    ...prevState,
                    isShowAddTariffItemPanel: true,
                    isAddTariffItem: true,
                    isEditTariffItem: false,
                    currentSelectItem: {
                        ...EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY,
                        dummyKey: _.uniqueId(),
                    },
                }
            });
        }
    }

    const onTariffItemFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                initTariffCode: "tariffType" === fieldKey && val !== prevState.currentSelectItem.tariffType,
                currentSelectItem: {
                    ...prevState.currentSelectItem,
                    [fieldKey]: val,
                },
                detailState: {
                    ...prevState.detailState,
                    allFormState: {
                        ...prevState.detailState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onAddIs = () => {
        return standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                isAddIs: true,
                isAddTier: false,
                currentTariffItemIs: { ...EMPTY_STD_PROPOSAL_IS_ENTITY }
            }
        });
    }

    const onAddTier = () => {
        return standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                isAddIs: false,
                isAddTier: true,
                currentTariffItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY }
            }
        });
    }

    const onTariffItemTierCloseClick = () => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowAddTariffItemPanel: false,
                isAddIs: false,
                isAddTier: false,
                currentTariffItem: { ...EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY },
                detailState: {
                    ...prevState.detailState,
                    allFormState: {
                    },
                }
            }
        })
    }


    const onTariffItemTierEidtClick = () => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                isEditTier: true,
                isEditIs: false,
                isAddIs: false,
                isAddTier: false,
                currentTariffItemTier: prevState.tariffItemTierSelectedRows.length === 1 ? prevState.tariffItemTierSelectedRows[0] : prevState.currentTariffItemTier,
            }
        })
    }

    const onTariffItemISEidtClick = () => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                isEditIs: true,
                isEditTier: false,
                isAddIs: false,
                isAddTier: false,
                currentTariffItemIs: prevState.currentTariffItemIs,
            }
        })
    }
    const updateSelectedTariffItemTierRows = async (rows: any[]) => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                tariffItemTierSelectedRows: rows,
                currentTariffItemTier: rows.length === 1 ? rows[0] : { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY },
            }
        })
    }

    const updateSelectedTariffItemIsRows = async (rows: any[]) => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                tariffItemIsSelectedRows: rows,
                currentTariffItemIs: rows.length === 1 ? rows[0] : { ...EMPTY_STD_PROPOSAL_IS_ENTITY },
            }
        })
    }

    const onTierFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        if (!val) {
            standardProposalDetailDispatch(prevState => {
                return {
                    ...prevState,
                    currentTariffItemTier: {
                        ...prevState.currentTariffItemTier,
                        [fieldKey]: val
                    },
                    detailState: {
                        ...prevState.detailState,
                        allFormState: {
                            ...prevState.detailState.allFormState,
                            [fieldKey]: ''
                        },
                    }
                }
            })
        } else {
            standardProposalDetailDispatch(prevState => {
                if (prevState.currentTariffItemTier && (fieldKey === 'cycle' || fieldKey === 'forevery')) {
                    var posIntReg = /^\d*$/;
                    if (!posIntReg.test(val)) {
                        val = prevState.currentTariffItemTier[fieldKey];
                    }
                }
                if (prevState.currentTariffItemTier && (fieldKey === 'rate' || fieldKey === 'minimum' || fieldKey === 'surcharge' || fieldKey === 'additionalRate')) {
                    var numberReg = /^\d*(\.\d{0,2})?$/;
                    if (!numberReg.test(val)) {
                        val = prevState.currentTariffItemTier[fieldKey];
                    }
                }
                return {
                    ...prevState,
                    currentTariffItemTier: {
                        ...prevState.currentTariffItemTier,
                        [fieldKey]: val
                    },
                    detailState: {
                        ...prevState.detailState,
                        allFormState: {
                            ...prevState.detailState.allFormState,
                            [fieldKey]: ''
                        },
                    }
                }
            })

        }

    }

    const onIsFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                currentTariffItemIs: {
                    ...prevState.currentTariffItemIs,
                    [fieldKey]: val
                },
                detailState: {
                    ...prevState.detailState,
                    allFormState: {
                        ...prevState.detailState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const cancelAdd = () => {
        return standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                isAddIs: false,
                isEditIs: false,
                isAddTier: false,
                isEditTier: false,
                currentTariffItemTier: prevState.currentTariffItemTier,
                currentTariffItemIs: prevState.currentTariffItemIs,
                detailState: {
                    ...prevState.detailState,
                    allFormState: {},
                }
            }
        });
    }

    const onSaveClick = (isAddTariffItem: boolean, isAddIs: boolean, isAddTier: boolean) => {
        if (isAddTariffItem) {
            if (isAddIs) {
                return standardProposalDetailDispatch(prevState => {
                    let isList = prevState.currentSelectItem.stdIsList;
                    isList?.push(prevState.currentTariffItemIs);
                    let itemList = prevState.standardProposalItemList;
                    itemList?.push(prevState.currentSelectItem);
                    return {
                        ...prevState,
                        currentSelectItem: {
                            ...prevState.currentSelectItem,
                            stdIsList: isList
                        },
                        isAddIs: false,
                        standardProposalItemList: itemList,
                        currentTariffItemIs: { ...EMPTY_STD_PROPOSAL_IS_ENTITY }
                    }
                });
            }
            if (isAddTier) {
                return standardProposalDetailDispatch(prevState => {
                    let tierList = prevState.currentSelectItem.tierList;
                    tierList?.push(prevState.currentTariffItemTier);
                    let itemList = prevState.standardProposalItemList;
                    itemList?.push(prevState.currentSelectItem);
                    return {
                        ...prevState,
                        currentSelectItem: {
                            ...prevState.currentSelectItem,
                            tierList: tierList
                        },
                        standardProposalItemList: itemList,
                        isAddTier: false,
                        currentTariffItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY }
                    }
                });
            }
            return standardProposalDetailDispatch(prevState => {
                let itemList = prevState.standardProposalItemList;
                itemList?.push(prevState.currentSelectItem);
                return {
                    ...prevState,
                    standardProposalItemList: itemList,
                    isAddTariffItem: false,
                    isEditTariffItem: false,
                    isShowAddTariffItemPanel: false,
                    currentTariffItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY }
                }
            });
        }
    }

    const initComboBoxTariffCode = async (entity: StandardProposalEntity, tariffType: string) => {
        standardProposalDetailDispatch(prevState => ({
            ...prevState,
            currentSelectItem: {
                ...prevState.currentSelectItem,
                tariffCode: prevState.isAddTariffItem ? "" : prevState.currentSelectItem.tariffCode,
            },
            initTariffCode: false,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                tariffCodeDropdownOptions: [],
            }
        }))
        const criteria: TariffCodeComboxSearchCriteria = {
            stdProposal: entity,
            tariffType: tariffType ?? "all",
        }
        const tariffCodes = await standardTariffCodeRepo.getTariffCodeForStdProposal(criteria);
        let tariffCodeDropdownOptions = tariffCodes?.map((tariffCode) => ({
            dropdownLabel: tariffCode.split(':')[1],
            tagLabel: tariffCode.split(':')[1],
            value: tariffCode.split(':')[1],
        })) ?? []
        standardProposalDetailDispatch(prevState => ({
            ...prevState,
            tariffCodeIds: tariffCodes,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                tariffCodeDropdownOptions: tariffCodeDropdownOptions,
            }
        }))
    }

    const onSaveClicked = () => {
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                detailState: {
                    ...prevState.detailState,
                    isSaveClicked: true,
                    // allFormState: {},
                }
            }
        })
    }
    const onTempSaveTariffItemTier = async (isAddTier: boolean,
        currentItem: StandardProposalItemEntity, currentTier: StdProposalTariffItemTierEntity) => {
        const valResult = await Validation(createTempSaveTariffItemTierValidationSchema).ValidateFormOnly(currentTier);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDetailDispatch(prevState => {
                return {
                    ...prevState,
                    detailState: {
                        ...prevState.detailState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
        } else {
            let newTiers: StdProposalTariffItemTierEntity[] = [];
            if (currentItem.tierList) {
                newTiers = currentItem.tierList?.slice();
                if (isAddTier) {
                    currentTier = {
                        ...currentTier,
                        tierNo: newTiers.length + 1,
                        newRecord: true,
                    }
                    newTiers.push(currentTier);
                } else {
                    newTiers = newTiers.map(entity => entity.tierNo === currentTier.tierNo ? currentTier : entity);
                }
            } else {
                currentTier = {
                    ...currentTier,
                    tierNo: newTiers.length + 1,
                    newRecord: true,
                }
                newTiers.push(currentTier);
            }
            standardProposalDetailDispatch(prevState => {
                return {
                    ...prevState,
                    isEditTier: false,
                    isAddTier: false,
                    currentTariffItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY },
                    currentSelectItem: {
                        ...prevState.currentSelectItem,
                        tierList: newTiers,
                    },
                    detailState: {
                        ...prevState.detailState,
                        allFormState: {},
                    }

                }
            })
        }
    }

    const onTempSaveTariffItemIs = async (isAddIs: boolean,
        currentItem: StandardProposalItemEntity, currentIs: StdProposalIsEntity
    ) => {
        let newIsList: StdProposalIsEntity[] = [];
        if (currentItem.stdIsList) {
            newIsList = currentItem.stdIsList?.slice();
            if (isAddIs) {
                newIsList.push(currentIs);
            } else {
                newIsList = newIsList.map(entity => entity.shiftCode === currentIs.shiftCode ? currentIs : entity);
            }
        } else {
            newIsList.push(currentIs);
        }
        standardProposalDetailDispatch(prevState => {
            return {
                ...prevState,
                isEditIs: false,
                isAddIs: false,
                currentTariffItemIs: { ...EMPTY_STD_PROPOSAL_IS_ENTITY },
                currentSelectItem: {
                    ...prevState.currentSelectItem,
                    stdIsList: newIsList,
                }

            }
        })
    }

    const onTempSaveTariffItem = async (proposalItemList: StandardProposalItemEntity[], proposalItem: StandardProposalItemEntity) => {
        const valResult = await Validation(createTariffItemValidationSchema).ValidateFormOnly(proposalItem);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDetailDispatch(prevState => {
                return {
                    ...prevState,
                    detailState: {
                        ...prevState.detailState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
        } else {
            let newItemList: StandardProposalItemEntity[] = [];
            newItemList = proposalItemList?.filter(dtl => (dtl.key !== null && dtl.key !== proposalItem.key)
                || ((dtl.key === null || dtl.key === "") && dtl.dummyKey !== proposalItem.dummyKey));
            newItemList.push(proposalItem);
            // let msg: string | null = null;
            standardProposalDetailDispatch(prevState => {
                // let proposalItemList = prevState.standardProposalItemList;
                // let proposalItem = prevState.currentSelectItem;
                // let newItemList: StandardProposalItemEntity[] = [];
                // newItemList = proposalItemList?.slice();
                // newItemList.push(proposalItem);
                // if (prevState.isAddTariffItem) {
                //     if (!prevState.currentSelectItem.tariffType) {
                //         msg = "Tariff Type is mandatory.";
                //     }
                //     if (msg === null && !prevState.currentSelectItem.tariffCode) {
                //         msg = "Tariff Code is mandatory.";
                //     }
                // }
                // if (msg === null && prevState.standardProposalItemList && prevState.standardProposalItemList.length > 0) {
                //     if (prevState.standardProposalItemList?.some(item =>
                //         item.tariffType === prevState.currentSelectItem.tariffType &&
                //         item.tariffCode === prevState.currentSelectItem.tariffCode &&
                //         item.forwarderCode === prevState.currentSelectItem.forwarderCode
                //     )) {
                //         msg = "Duplicate record found, please check the key: Tariff Type, Tariff Code, Forwarder Code.";
                //     }
                // }
                // if (msg === null && prevState.currentSelectItem.tierList && prevState.currentSelectItem.tierList.length === 0) {
                //     msg = "Must add one tariff item tier at least.";
                // }
                // if (!prevState.isAddTariffItem || !prevState.currentSelectItem.tierList || prevState.currentSelectItem.tierList.length <= 0) {
                //     msg = "";
                // }
                // if (msg !== null) {
                //     return {
                //         ...prevState
                //     }
                // } else {
                return {
                    ...prevState,
                    standardProposalItemList: newItemList,
                    isEditIs: false,
                    isAddIs: false,
                    isAddTariffItem: false,
                    isEditTariffItem: false,
                    isShowAddTariffItemPanel: false,
                    currentTariffItemIs: { ...EMPTY_STD_PROPOSAL_IS_ENTITY },
                    currentTariffItemTier: { ...EMPTY_STD_PROPOSAL_TARIFF_ITEM_TIER_ENTITY },
                    currentSelectItem: { ...EMPTY_STANDARD_PROPOSAL_ITEM_ENTITY },
                    detailState: {
                        ...prevState.detailState,
                        allFormState: {
                        },
                    }
                }
                // }

            })
            // return msg;
        }
    }

    const onSaveStdProposal = async (tariffCodeIds: string[], stdProposal: StandardProposalEntity, itemList: StandardProposalItemEntity[]) => {
        const valResult = await Validation(createStandardProposalValidationSchema).ValidateFormOnly(stdProposal);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            standardProposalDetailDispatch(prevState => {
                return {
                    ...prevState,
                    detailState: {
                        ...prevState.detailState,
                        allFormState: validatedResult
                    }
                }
            });
            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }

        const newItemList = itemList?.map((item, index) => ({
            ...item,
            priority: index + 1
        }))

        let criteria: SaveTariffProposalItemCriteria = {
            tariffProposal: stdProposal,
            tariffCodeIds: tariffCodeIds,
            itemList: newItemList,
            deleteItemList: [],
        }
        return await standardProposalItemRepo.saveNewStandardProposal(criteria);
    }

    const onTariffItemDeleteClick = async (deleteItems: StandardProposalItemEntity[]) => {
        standardProposalDetailDispatch(prevState => {
            let itemList = prevState.standardProposalItemList ?? [].slice();
            const newList = itemList.filter(item =>
                !deleteItems?.some(delItem => item.tariffType === delItem.tariffType && item.tariffCode === delItem.tariffCode)
            );
            return {
                ...prevState,
                standardProposalItemList: newList,
            }
        })
    }

    const onTariffItemIsDeleteClick = async (deleteIs: StdProposalIsEntity[]) => {
        standardProposalDetailDispatch(prevState => {
            let isList = prevState.currentSelectItem.stdIsList ?? [].slice();
            const newList = isList.filter(is =>
                !deleteIs?.some(delIs => is.shiftCode === delIs.shiftCode)
            );
            return {
                ...prevState,
                currentSelectItem: {
                    ...prevState.currentSelectItem,
                    stdIsList: newList,
                },
            }
        })
    }

    const onTariffItemTierDeleteClick = async (deleteTiers: StdProposalTariffItemTierEntity[]) => {
        standardProposalDetailDispatch(prevState => {
            let tierList = prevState.currentSelectItem.tierList ?? [].slice();
            const newList = tierList.filter(tier =>
                !deleteTiers?.some(delTier => tier.tierNo === delTier.tierNo)
            ).map((tier, i) => ({ ...tier, tierNo: i + 1 }));
            return {
                ...prevState,
                currentSelectItem: {
                    ...prevState.currentSelectItem,
                    tierList: newList,
                },

            }
        })

    }

    const onClearMessage = () => {
        standardProposalDetailDispatch(prevState => ({
            ...prevState,
            allFormState: { "updateNewTariffNatureFail": '' }
        }))
    }

    return {
        onTariffItemTierDeleteClick: onTariffItemTierDeleteClick,
        onTariffItemIsDeleteClick: onTariffItemIsDeleteClick,
        onTariffItemDeleteClick: onTariffItemDeleteClick,
        onSaveStdProposal: onSaveStdProposal,
        cancelAdd: cancelAdd,
        onIsFieldChange: onIsFieldChange,
        onTierFieldChange: onTierFieldChange,
        updateSelectedTariffItemIsRows: updateSelectedTariffItemIsRows,
        updateSelectedTariffItemTierRows: updateSelectedTariffItemTierRows,
        onTariffItemISEidtClick: onTariffItemISEidtClick,
        onTariffItemTierEidtClick: onTariffItemTierEidtClick,
        onTariffItemTierCloseClick: onTariffItemTierCloseClick,
        onPageInit: onPageInit,
        // loadDropdownOption: loadDropdownOption,
        onHeaderFieldChange: onHeaderFieldChange,
        onDateRangeChange: onDateRangeChange,
        onTextAreaChange: onTextAreaChange,
        searchStandardProposalItem: searchStandardProposalItem,
        updateSelectedRows: updateSelectedRows,
        onCloseClick: onCloseClick,
        onResetClick: onResetClick,
        onHeaderMultipleDropdownChange: onHeaderMultipleDropdownChange,
        onHeaderSingleDropdownChange: onHeaderSingleDropdownChange,
        onAddTariffItemClick: onAddTariffItemClick,
        onTariffItemFieldChange: onTariffItemFieldChange,
        onAddIs: onAddIs,
        onAddTier: onAddTier,
        onSaveClick: onSaveClick,
        initComboBoxTariffCode: initComboBoxTariffCode,
        onTempSaveTariffItemIs: onTempSaveTariffItemIs,
        onTempSaveTariffItemTier: onTempSaveTariffItemTier,
        onTempSaveTariffItem: onTempSaveTariffItem,
        onTariffNatureFieldChange: onTariffNatureFieldChange,
        onSaveClicked: onSaveClicked,
        onClearMessage: onClearMessage,

    }
}